import React, { FC, useEffect, useState } from 'react';
import MomentUtils from '@date-io/moment';
import moment, { Moment } from 'moment';
import {
  DatePicker as MuiDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { TextFieldProps } from '@material-ui/core/TextField';
import { DatePickerView } from '@material-ui/pickers/DatePicker/DatePicker';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { datePickerTheme } from './datePicker.theme';

interface IDatePicker {
  className?: string;
  value: Moment | null;
  onChange: (date: Moment) => void;
  label: string;
  variant: TextFieldProps['variant'];
  disabled: boolean;
  maxDate?: Moment;
  maxDateMessage?: string;
  minDate?: Moment;
  minDateMessage?: string;
  disableFuture?: boolean;
  views?: DatePickerView[];
  format?: string;
  size?: 'small' | 'medium';
  name?: string;
}

export const DatePicker: FC<IDatePicker> = ({
  className,
  value,
  onChange,
  label,
  variant,
  disabled,
  maxDate,
  maxDateMessage,
  minDate,
  minDateMessage,
  disableFuture,
  views,
  format,
  size,
  name,
}) => {
  const [selectedDate, setSelectedDate] = useState(value);

  useEffect(() => {
    if (value) {
      setSelectedDate(value);
    }
  }, [value]);

  const handleOnChange = (date: MaterialUiPickersDate) => {
    setSelectedDate(date);

    if (onChange) {
      onChange(date as Moment);
    }
  };

  return (
    <MuiThemeProvider theme={datePickerTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
        <MuiDatePicker
          className={className}
          inputVariant={variant}
          label={label}
          disabled={disabled}
          disableFuture={disableFuture}
          maxDate={maxDate}
          maxDateMessage={maxDateMessage}
          minDate={minDate}
          minDateMessage={minDateMessage}
          format={format || 'MM/DD/yyyy'}
          value={selectedDate}
          onChange={handleOnChange}
          animateYearScrolling
          views={views}
          size={size}
          name={name}
        />
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};
